export default __webpack_public_path__ + "static/media/evz-logo.9eedbcbb.svg";